import { useRef, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '@/components/layout/Container';
import { Section } from '@/components/layout/Section';
import { Eyebrow } from '@/components/domain/Eyebrow';
import { useFadeUpOnScroll } from '@/hooks/useFadeUpOnScroll';
import styles from './ScenarioSection.module.css';

export const ScenarioSection: FC = () => {
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  useFadeUpOnScroll(ref, { selector: '[data-fade]', stagger: 0.1 });

  const steps = t('home.scenario.steps', { returnObjects: true }) as Array<{
    title: string;
    body: string;
  }>;

  return (
    <Section tone="muted" id="scenario">
      <Container size="default">
        <div ref={ref}>
          <header className={styles.header}>
            <div data-fade>
              <Eyebrow>{t('home.scenario.kicker')}</Eyebrow>
            </div>
            <h2 className={styles.title} data-fade>
              {t('home.scenario.title')}
            </h2>
          </header>
          <ol className={styles.timeline}>
            {steps.map((s, idx) => (
              <li key={s.title} className={styles.step} data-fade>
                <div className={styles.marker}>
                  <span className={styles.index}>{String(idx + 1).padStart(2, '0')}</span>
                  <span className={styles.connector} aria-hidden="true" />
                </div>
                <div className={styles.body}>
                  <h3 className={styles.stepTitle}>{s.title}</h3>
                  <p className={styles.stepBody}>{s.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </Container>
    </Section>
  );
};

ScenarioSection.displayName = 'ScenarioSection';
